import {PRICE} from 'shared/lib'
import styles from './styles.module.scss'

export const ChatPrice = () => {
  return (<span className={styles.price}>Cost of Live Chat is {PRICE.CHAT} GoCoins/min.</span>)
}
